import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';
import { SignUpComponent } from "./sign-up/sign-up.component";
import { LoginComponent } from "./login/login.component";
import { HomeComponent } from './home/home.component';
import { DocumentTypeComponent } from './document-type/document-type.component';
import { DocumentTypeEditComponent } from './document-type-edit/document-type-edit.component';
import { DocumentComponent } from './documents/document/document.component';
import { DocumentListComponent } from './documents/document-list/document-list.component';
import { DocumentViewHistoryComponent } from './documents/document-view-history/document-view-history.component';
import { ProfileComponentComponent } from './components/profile-component/profile-component.component';

const routes: Routes = [
  {
    path: 'signup',
    component: SignUpComponent
  },
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: 'profile',
    component: ProfileComponentComponent
  },
  {
    path: 'documentType/edit/:id',
    component: DocumentTypeEditComponent
  }, 
  {
    path: 'documentType/add',
    component: DocumentTypeEditComponent
  },   
  {
    path: 'documentType',
    component: DocumentTypeComponent
  },  
  {
    path: 'document/add/:typeId',
    component: DocumentComponent
  },
  {
    path: 'documents',
    component: DocumentListComponent
  },
  {
    path: 'document/edit/:id',
    component: DocumentComponent
  },
  {
    path: 'document/history/:id',
    component: DocumentViewHistoryComponent
  },       
  { path: 'home', component: HomeComponent },
  { path: '', component: HomeComponent, pathMatch: 'full' },
  {
    path: 'administration',
    loadChildren: ()=> require("./modules/administration/administration.module")["AdministrationModule"]
  },  
  {
    path: 'timeTracking',
    loadChildren: ()=> require("./modules/time-tracking/time-tracking.module")["TimeTrackingModule"]
  },
  {
    path: 'plasard-measurement',
    loadChildren: ()=> require("./modules/plasard-measurement/plasard-measurement.module")["PlasardMeasurementModule"]
  },
  {
    path: 'analytics',
    loadChildren: ()=> require("./modules/analytics/analytics.module")["AnalyticsModule"]
  }      
];

@NgModule({
  imports: [RouterModule.forRoot(routes,  
    { 
      preloadingStrategy: PreloadAllModules
    })],
  exports: [RouterModule]
})

export class AppRoutingModule {

}
export const routingComponents = [SignUpComponent];
